export class UserDetails {
  EmailID: string;
  BU:string;
  Username:string;
  Role: string;
}
